import { CompanyPeople } from '@/components/admin/sponsorships/Sponsors/components/Company/components/CompanyPeople';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(CompanyPeople, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});
